import { get, post } from '../utils/request';



// 获取产品详情
// export const getProductDetail = (query:any) => {
//   return get<any>('/product/get_product_by_id',query);
// };


// 店铺认证
export const saveApplyMerchant = (params:any) => {
  return post<any>('/merchant/save_merchant',params);
};



// 获取店铺列表 
export const getWebStoreList = (params:any) => {
  return get<any>('/web/get_merchant_page_list_with_product',params);
};


// 获取店铺详情
export const getWebStoreDetail = (params:any) => {
  return get<any>('/web/get_products_page_list_by_merchant_channel_id',params);
};


// 获取店铺频道
export const getWebStoreChannel = (params:any) => {
  return get<any>('/web/get_merchant_channel_list_by_merchant_id',params);
};


// 关注/取消关注 店铺
export const saveUserFollow = (params:any) => {
  return post<any>('/user/save_user_follow',params);
};


// 查看是否关注店铺 user/get_check_is_follow
export const getCheckIsFollow = (params:any) => {
  return get<any>('/user/get_check_is_follow',params);
};


// 获取店铺详情
export const getMerchantInfo = (params:any) => {
  return get<any>('/web/get_merchant_info',params);
};

// 获取店铺仪表盘统计
export const getMerchantDashboardCount = (params:any) => {
  return get<any>('/merchant/get_merchant_dashboard_count',params);
};